import { AxiosResponse } from 'axios';
import http from './http-common';

class NotificationService {
  async markNotificationsAsViewed(notificationIds: string[]): Promise<AxiosResponse> {
    return http.post('/notification/viewed', { notificationIds });
  }
}

const notificationService = new NotificationService();
export default notificationService;
